/**
 * Papéis de usuário no sistema (multi-tenant)
 */
export enum UserRole {
  Admin = 'admin',
  Member = 'member',
  Guest = 'guest',
  Viewer = 'viewer',
}
